import React, { useState } from "react";
import ProfDashboardLayout from "./ProfDashboardLayout";
import Chat from "../../../components/Chat/Chat";

const ProfChat = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <ProfDashboardLayout>
        <Chat />
      </ProfDashboardLayout>
    </>
  );
};

export default ProfChat;
